// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-8fadd94a] {\n  width: 250px;\n  border-radius: 10px;\n}\n.icon-holder[data-v-8fadd94a] {\n  position: absolute;\n  height: 1rem;\n  width: 1rem;\n  top: 10px;\n  left: 14px;\n}\n.searchv2[data-v-8fadd94a]{\n  width: -moz-available;\n  width: -webkit-fill-available;\n  width: fill-available;\n}\n", ""]);
// Exports
module.exports = exports;
